<template>
  <v-app style="height:100%;">
      <v-card class="pa-2 mr-2 ml-2 mt-8" style="border: solid;" align="left">
          <div><b>ท่านสามารถชำระผ่านการโอนเงิน</b></div>
          <div><b>ชื่อบัญชี : </b>บริษัท เอตทัคคะ วิศวกรรม จำกัด</div>
          <div><b>หมายเลขบัญชี : </b>ธนาคารกรุงไทย 660-7-74342-0</div>
          <div><b>หมายเลขพร้อมเพย์ : </b> 0105558194986</div>
      </v-card>

      <v-card class="pa-2 mr-2 ml-2 pt-4 mt-2" style="border: solid;" align="center">
          <QrcodeVue :value="qrcode" size="250" level="M"></QrcodeVue>
      </v-card>

      <v-card class="pa-2 mb-4 mr-2 ml-2 pt-4 mt-2" style="border: solid;" align="left">
          
          <div><b>ยอดที่ต้องโอน : {{amt}} บาท</b></div>
          <div>REF : {{ $route.params.order_id }}</div>
      </v-card>

        <v-row>


        </v-row>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import QrcodeVue from 'qrcode.vue'
import crc from 'crc'

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  components: {
    QrcodeVue
  },
  data () {
    return {
      qrcode : ""
      ,amt : 0
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.specialmarket.get_ordermeta
        ,{ order_id: this.$route.params.order_id }
        ,{ headers: Member.getTokenHeader()}
      )
      .then(response => {

        this.$store.commit('finishLoading',que)
        this.amt = parseInt(response.data.total_price) + parseInt(response.data.total_fee)
        var amount = parseInt(response.data.total_price) + parseInt(response.data.total_fee)
        var data = '00020101021229370016A000000677010111021301055581949865802TH54'
        amount = amount.toFixed(2).toString()
        data += ('00' + amount.length).slice(-2) + amount + '5303764'
        var dataToCrc = data + '6304'
        var crcData = crc.crc16xmodem(dataToCrc, 0xffff)
        crcData = ('0000' + crcData.toString(16).toUpperCase()).slice(-4)
        data += '63' + ('00' + crcData.length).slice(-2) + crcData
        this.qrcode = data

      })
  },
  methods : {
  }
}

</script>